function closeModal () {
    $('.modal').fadeOut();
}

$('.modal').on('click', function(e) {
    if ($(e.target).closest('.modal-content').length == 0) {
        closeModal();
    }
});

$('.modal button').on('click', function() {
    closeModal();
});

$(document).keyup(function(e) {
    if (e.key === "Escape") { // escape key maps to keycode `27`
        closeModal();
    }
});

if ($('.is-invalid, .invalid-feedback, .error').length) {
    var y = $('.is-invalid, .invalid-feedback, .error').eq(0).parents('.form-group').offset().top - $('header').height() - 10;
    window.scrollTo({
        top: y,
    });
}

$(document).on('click', '.btn-save-subscription', function(e) {
    let $form = $('form.form-default');
    $form.append('<input type="hidden" name="draft" value="1">');
});

// $('[name="pro_identity_other"]').on('keyup', function() {
//     if($(this).val().length > 0) {
//         $('#pro_identity_99').prop('checked', true);
//     }
// });

// $('[name="has_ecommerce_url"]').on('keyup', function() {
//     if($(this).val().length > 0) {
//         $('#has_ecommerce_yes').prop('checked', true);
//     }
// });

// $('[name="job_class_other"]').on('keyup', function() {
//     if($(this).val().length > 0) {
//         $('#job_class_99').prop('checked', true);
//     }
// });

// $('[name="gender_other"]').on('keyup', function() {
//     if($(this).val().length > 0) {
//         $('#gender_99').prop('checked', true);
//     }
// });

// $('[name="color_other"]').on('keyup', function() {
//     if($(this).val().length > 0) {
//         $('#color_99').prop('checked', true);
//     }
// });

// $('[name="marketplaces_other"]').on('keyup', function() {
//     if($(this).val().length > 0) {
//         $('#marketplaces_99').prop('checked', true);
//     }
// });

// $('#nao-tenho-loja-online-ativa').on('change', function(e) {
//     e.preventDefault();
//     if($(this).is(':checked')) {
//         $('#sim-em-plataforma-de-marketplace').prop('disabled', true).prop('checked', false);
//         $('#sim-em-plataforma-propria').prop('disabled', true).prop('checked', false);
//         $('input[name="marketplaces[]"]').prop('disabled', true).prop('checked', false);
//     } else {
//         $('#sim-em-plataforma-de-marketplace').prop('disabled', false);
//         $('#sim-em-plataforma-propria').prop('disabled', false);
//         $('input[name="marketplaces[]"]').prop('disabled', false);
//     }
// });

// $('#nao-tenho-loja-online-ativa').trigger('change');

